// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClusterSpecInput } from './ClusterSpecInput';
import {
  ClusterSpecInputFromJSON,
  ClusterSpecInputFromJSONTyped,
  ClusterSpecInputToJSON,
  ClusterSpecInputToJSONTyped,
} from './ClusterSpecInput';
import type { MetadataInput } from './MetadataInput';
import {
  MetadataInputFromJSON,
  MetadataInputFromJSONTyped,
  MetadataInputToJSON,
  MetadataInputToJSONTyped,
} from './MetadataInput';

/**
 *
 * @export
 * @interface CreateCluster
 */
export interface CreateCluster {
  /**
   *
   * @type {MetadataInput}
   * @memberof CreateCluster
   */
  metadata?: MetadataInput;
  /**
   *
   * @type {ClusterSpecInput}
   * @memberof CreateCluster
   */
  spec?: ClusterSpecInput;
}

/**
 * Check if a given object implements the CreateCluster interface.
 */
export function instanceOfCreateCluster(value: object): value is CreateCluster {
  return true;
}

export function CreateClusterFromJSON(json: any): CreateCluster {
  return CreateClusterFromJSONTyped(json, false);
}

export function CreateClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateCluster {
  if (json == null) {
    return json;
  }
  return {
    metadata:
      json['metadata'] == null
        ? undefined
        : MetadataInputFromJSON(json['metadata']),
    spec:
      json['spec'] == null ? undefined : ClusterSpecInputFromJSON(json['spec']),
  };
}

export function CreateClusterToJSON(json: any): CreateCluster {
  return CreateClusterToJSONTyped(json, false);
}

export function CreateClusterToJSONTyped(
  value?: CreateCluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metadata: MetadataInputToJSON(value['metadata']),
    spec: ClusterSpecInputToJSON(value['spec']),
  };
}
